import React, { useCallback, useEffect, useState, useRef } from "react"

import useEmblaCarousel from 'embla-carousel-react'

import useMobileDetect from 'use-mobile-detect-hook'
import ArrowLeft from "images/svg/icons/arrow-left.svg"
import ArrowRight from "images/svg/icons/arrow-right.svg"

import "./slides.scss"

const detectMobile = useMobileDetect()
const isMobile = detectMobile.isMobile()

const SliderEmbla = ({
  cardClass,
  has_header,
  header = null,
  numSlides = 3,
  onChange,
  showButtons = true,
  padding = 20,
  style = 'carousel',
  title,
  ...props
}) => {
  const [slidesPerView, setSlidesPerView] = useState(numSlides)
  setTimeout(() => {
    setSlidesPerView(numSlides + 0.01)
  }, 200);

  const options = {
    loop: false,
    align: "start",
    skipSnaps: false,
    slidesToScroll: 1,
  }

  const [emblaRef, emblaApi] = useEmblaCarousel(options)

  // Track the current slide index
  const logSlidesInView = useCallback((emblaApi) => {
    console.log(emblaApi.slidesInView())
    const indexCurrent = emblaApi.selectedScrollSnap()
    if (onChange) {
      onChange(null, indexCurrent) // no ref, just index
    }
  }, [])

  useEffect(() => {
    if (emblaApi) emblaApi.on('slidesInView', logSlidesInView)
  }, [emblaApi, logSlidesInView])

  const prevButton = useRef()
  const nextButton = useRef()
  const cards = props?.data || []


  const updateButtons = useCallback(() => {
    if (emblaApi && prevButton.current && nextButton.current) {
      if (emblaApi.canScrollPrev()) {
        prevButton.current.classList.remove("disabled");
      } else {
        prevButton.current.classList.add("disabled");
      }

      if (emblaApi.canScrollNext()) {
        nextButton.current.classList.remove("disabled");
      } else {
        nextButton.current.classList.add("disabled");
      }

      if (props.theme === "light") {
        prevButton.current.classList.add("light");
        nextButton.current.classList.add("light");
      } else {
        prevButton.current.classList.remove("light");
        nextButton.current.classList.remove("light");
      }
    }
  }, [emblaApi, props.theme])

  useEffect(() => {
    if (emblaApi) {
      emblaApi.on("select", updateButtons);
      emblaApi.on("reInit", updateButtons);

      // Also update buttons immediately after emblaApi is ready
      updateButtons();

      // Cleanup listeners on unmount or emblaApi change
      return () => {
        emblaApi.off("select", updateButtons);
        emblaApi.off("reInit", updateButtons);
      };
    }
  }, [emblaApi, updateButtons])

  useEffect(() => {
    if (props.goToSlide && emblaApi) {
      emblaApi.scrollTo(props.goToSlide);
    }
  }, [props.goToSlide, emblaApi]);

  const nextSlide = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (emblaApi) emblaApi.scrollNext();
  }

  const prevSlide = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (emblaApi) emblaApi.scrollPrev();
  }

  const sliderContainerStyle = {
    height: `100%`,
  }

  const styleSwiperButtons = {
    display: has_header ? 'inline' : 'inline-block',
    position: 'absolute',
    right: 0,
    top: 0,
  }

  const styleSwiperButton = {
    background: '#eee',
    cursor: 'pointer',
    display: 'inline-block',
    position: 'absolute',
    padding: `2px`,
    zIndex: 10,
  }

  const classButtons = `swipper-buttons ${has_header ? 'has__header' : ''}`

  const SwiperButtons = (
    <div className={classButtons} style={styleSwiperButtons}>
      <button
        ref={prevButton}
        onClick={prevSlide}
        className="button swiper-button swiper-button-prev"
        style={styleSwiperButton}
        tabIndex={0}>
        <ArrowLeft />
      </button>
      <button
        ref={nextButton}
        onClick={nextSlide}
        className="button swiper-button swiper-button-next"
        style={styleSwiperButton}
        tabIndex={0}>
        <ArrowRight />
      </button>
    </div>
  )

  const emblaOverflow = { overflow: 'hidden' }
  const emblaContainer = { display: 'flex', ...sliderContainerStyle }
  const slideClass = `embla__slide ${cardClass ? cardClass : ""} ${cards?.length === 1 ? "single" : "cards-" + cards?.length}`
  // Dynamically set slide width based on slidesPerView (numSlides)
  const slideWidthPercent = slidesPerView > 0 ? (100 / slidesPerView) : 100
  const slideStyle = {
    marginLeft: '1rem',
    marginRight: '0.2rem',
    flex: `0 0 ${slideWidthPercent}%`,
    maxWidth: `${slideWidthPercent}%`,
    minWidth: 0,
  }

  return (
    <div className={`slider ui ${style}`} >
      {!isMobile && showButtons ? SwiperButtons : null}
      {header ? <h4 style={{ display: 'inline' }}>{header}</h4> : null}
      <section className="embla" style={emblaOverflow}>
        <div className="embla__viewport" ref={emblaRef}>
          <div className="embla__container" style={emblaContainer}>
            {cards.map((item, i) => (
              <div key={i} className={slideClass} style={slideStyle}>
                {item}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}

export default SliderEmbla